import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TextImageAnimation = () => {
  const containers = document.querySelectorAll(".text-image");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const overline = container.querySelectorAll(".text-image__overline");
      const headline = container.querySelectorAll(".text-image__headline");
      const subline = container.querySelectorAll(".text-image__subline");
      const image = container.querySelectorAll(".text-image__image");
      const productNameImage = container.querySelectorAll(
        ".product-name-image",
      );
      const text = container.querySelectorAll(".text-image__text");
      const button = container.querySelectorAll(".text-image__button .btn");
      const textColumn = container.querySelectorAll(".text-image__column");

      if (
        !overline.length &&
        !headline.length &&
        !subline.length &&
        !text.length &&
        !image.length &&
        !textColumn.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (overline.length) {
        tl.to(overline, { ...base, x: 0 }, 0);
      }

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 }, 0.2);
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 }, 0.4);
      }

      if (image.length) {
        tl.to(
          image,
          { opacity: 1, duration: 1, ease: "back.out(1.7, 0.5)", scale: 1 },
          0.6,
        );
      }

      if (productNameImage.length) {
        tl.to(productNameImage, base, 0.6);
      }
      if (text.length) {
        tl.to(text, base, 0.8);
      }

      if (textColumn.length) {
        tl.to(textColumn, { ...base, stagger: 0.15 }, 0.6);
      }

      if (button.length) {
        tl.to(
          button,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "back.out(1.7, 0.5)",
          },
          1,
        );
      }
    });
  };
  applyAnimations();
};

export default TextImageAnimation;
